import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import createBrowserHistory from 'history/createBrowserHistory';
import './index.css';
import App from './App';
import { unregister } from './registerServiceWorker';
import createStore from './redux/createStore';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import { createMuiTheme } from 'material-ui/styles';
import { CookiesProvider } from 'react-cookie';


const history = createBrowserHistory({});

const store = createStore(history);
const theme = createMuiTheme({
  typography: {
    fontFamily: [
      'Arial',
      'Helvetica',
      'sans-serif',
    ].join(','),

    display4: {
      fontSize: 90,
      fontWeight: 'bold',
    },

    display3: {
      fontSize: 40,
      fontWeight: 'bold',
      color: '#181819'
    },

    display2: {
      fontSize: 28,
      fontWeight: 'bold',
      color: '#181819'
    },

    display1: {
      fontSize: 20,
      fontWeight: 'bold',
      color: '#181819'
    },

    title: {
      fontSize: 18,
      color: '#181819'
    },

    subheading: {
      fontSize: 15,
      color: '#181819'
    },

    body2: {
      fontSize: 13,
      color: '#181819'
    },

    body1: {
      fontSize: 11,
      color: "#71737B",
    },

    caption: {
      fontSize: 8,
      color: "#71737B",
    }
  },

  palette: {
    primary: {
      light: '#6F9EFF',
      main: '#1A65FF',
      dark: '#1A65FF',
      contrastText: '#FFFFFF',
    },

    secondary: {
      main: '#F03A47',
      contrastText: '#FFFFFF',
    }
  },

  overrides: {
    MuiMenu: {
      paper: {
        marginTop: 12,
        background: '#FFFFFF',
        border: '1px solid #D8DBDF',
        boxShadow: '0 4px 8px rgba(0,0,0,.12)',
        maxHeight: '300px',
      },
    },

    MuiList: {
      root: {
        padding: '0px !important',
      },
    },

    MuiMenuItem: {
      root: {
        fontSize: 13,
        borderBottom: '1px solid #D8DBDF',
        '&:hover': {
          backgroundColor: 'rgba(26,101,255,.05)',
        },
        '&$selected': {
          backgroundColor: 'rgba(26,101,255,.1)',
        }
      },
    },

    MuiInputLabel: {
      shrink: {
        transform: 'translate(0, -2.5px) scale(1)'
      }
    },

    MuiInput: {
      input: {
        minWidth: 'unset',
        borderRadius: 2,
        backgroundColor: '#FFFFFF',
        border: '1px solid #ced4da',
        fontSize: '13px',
        padding: '10px 12px',
        '&:focus': {
          borderColor: '#1A65FF',
        },
      },

      error: {
        '& $input': {
          border: '1px solid #F03A47 !important',
        }
      },
    },

    MuiFormLabel: {
      root: {
        fontSize: '13px',
        color: '#181819',
      }
    },

    MuiCheckbox: {
      default: {
        color: '#D8DBDF',
      }
    }
  },
});

ReactDOM.render(
  <CookiesProvider>
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <MuiThemeProvider theme={theme}>
          <App />
        </MuiThemeProvider>
      </ConnectedRouter>
    </Provider>
  </CookiesProvider>,
  document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js